import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

const useNewsArticle = (
  id,
  newsList = []
) => {
  const [news, setNews] = useState(null);
  const [loading, setLoading] =
    useState(true);
  const [error, setError] =
    useState(null);

  useEffect(() => {
    let active = true;

    const loadNews = async () => {
      setLoading(true);
      setError(null);

      try {
        const cachedNews =
          newsList.find(
            (item) => item.id === id
          );

        if (cachedNews) {
          if (active) {
            setNews(cachedNews);
          }

          return;
        }

        const newsReference = doc(
          db,
          'news',
          id
        );

        const snapshot =
          await getDoc(newsReference);

        if (!snapshot.exists()) {
          if (active) {
            setNews(null);
            setError(
              'Новина не знайдена'
            );
          }

          return;
        }

        if (active) {
          setNews({
            id: snapshot.id,
            ...snapshot.data(),
          });
        }
      } catch (loadError) {
        console.error(
          'Помилка при завантаженні новини:',
          loadError
        );

        if (active) {
          setNews(null);
          setError(
            'Помилка при завантаженні новини'
          );
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    loadNews();

    return () => {
      active = false;
    };
  }, [id, newsList]);

  return {
    news,
    loading,
    error,
  };
};

export default useNewsArticle;